import { render, staticRenderFns } from "./SystemBar.vue?vue&type=template&id=25ff1fb5&scoped=true&"
import script from "./SystemBar.vue?vue&type=script&lang=js&"
export * from "./SystemBar.vue?vue&type=script&lang=js&"
import style0 from "./SystemBar.vue?vue&type=style&index=0&id=25ff1fb5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ff1fb5",
  null
  
)

export default component.exports